import type { ComponentProps, ReactNode } from "react";
import { cn } from "../lib/cn";

export interface EmptyStateProps extends Omit<ComponentProps<"div">, "title"> {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** A call to action, typically a `Button`. */
  action?: ReactNode;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
  ...props
}: EmptyStateProps) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        "flex flex-col items-center justify-center gap-2 px-6 py-16 text-center",
        className,
      )}
      {...props}
    >
      {icon !== undefined && (
        <div
          data-slot="empty-state-icon"
          className="mb-2 flex size-12 items-center justify-center rounded-lg bg-surface text-fg-muted [&_svg]:size-6 [&_svg]:stroke-[1.5]"
        >
          {icon}
        </div>
      )}
      <p data-slot="empty-state-title" className="text-base font-medium text-fg">
        {title}
      </p>
      {description !== undefined && (
        <p
          data-slot="empty-state-description"
          className="max-w-xs text-sm leading-relaxed text-fg-muted"
        >
          {description}
        </p>
      )}
      {action !== undefined && (
        <div data-slot="empty-state-action" className="mt-4">
          {action}
        </div>
      )}
    </div>
  );
}
